"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const chevron_down_svg_1 = __importDefault(require("@@/assets/svgs/chevron_down.svg"));
const Select_1 = __importDefault(require("@mui/material/Select"));
const styled_1 = __importDefault(require("@emotion/styled"));
exports.default = (0, styled_1.default)((props) => ((0, jsx_runtime_1.jsx)(Select_1.default, Object.assign({ variant: "standard", native: true, IconComponent: chevron_down_svg_1.default }, props)))) `
  display: flex;
  align-items: center;
  .MuiNativeSelect-select {
    height: 100%;
    padding: 0;
  }
  .MuiNativeSelect-icon {
    top: unset;
  }
`;
